import React from "react";
import { Loader } from "three";
import LoaderButton from "../components/LoaderButton";
import Modal from '../components/Modal'
import { translate } from "../utils/useful";


class IndoorPickerModal extends React.Component {
  state = {
    // selectedIndex:0,
    data: [
      { _id: '1234', image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },
      // { image: '/images/tempPlan.jpg' },

    ]
  }

  componentDidMount() {
    // this.setState({ countries: countriesCode })

  }

  showModal = () => {
    this.modal.showModal()
  }


  // search(value) {
  //   let data = this.state.data
  //   data = data.filter(e => e.name?.toLowerCase().includes(value.toLowerCase()))
  //   this.setState({ data })
  // }

  // subscribe = () => {
  //   this.setState({ errors: {} })
  //   // let data = this.form.getForm()
  //   // if (data) {
  //   this.setState({ isLoading: true })
  //   this.props.subscribe((success) => {
  //     this.setState({ isLoading: false })
  //     if (success) {
  //       this.modal.hideModal()
  //     }
  //   })

  //   // }
  // }

  changeSelect = (prop, index) => {
    let selectedIndex = index
    if (this.state.selectedIndex == index) {
      selectedIndex = null
    }
    console.log(selectedIndex)
    this.setState({ selectedIndex, currentItem: prop })
  }


  showBigImage = () => {
    this.imageModal.showModal()
  }


  doneClicked = () => {
    this.props.doneClicked(this.state.currentItem, () => {
      this.modal.hideModal()
    })
  }


  render() {
    return (

      <Modal ref={el => this.modal = el} maxWidth={800}>
        <div className=" w-100">
          <div className="w-100 d-flex flex-column" style={{ flex: 1, height: 'calc(100vh - 150px)', minHeight: '400px', backgroundColor: '#fff', overflow: 'auto', borderRadius: 8 }}>
            <div className="w-100" style={{ zIndex: 1, padding: '7px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>

              <p>Indoor Map Picker</p>

              <div className="flexc">
                <div className="cursor-pointer" onClick={() => this.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                </div>
              </div>
            </div>

            <div className="d-flex h-100" style={{ flex: 1 }}>



              <div className=" text-start w-100 " style={{ height: '100%' }}  >

                {this.state.isLoading && (
                  <div className="h-100 flexcc py-5 px-5 w-100">
                    <Loader
                      type={"Oval"}
                      color={"#202020"}
                      height={50}
                      width={50}
                    />
                  </div>
                )}

                {!this.state.isLoading && !this.state.data?.length && (
                  <div className="flexcc flex-column py-5 px-5 text-center">

                    <p className="mt-2 text-big text-bold">NO MAPS</p>
                    <p className="mt-1 mb-1">You need to add maps to use</p>

                    <button style={{ outline: 'none', backgroundImage: 'linear-gradient(to right bottom,#00A7DA,#6F7BBE)', cursor: 'pointer', padding: '6px 30px', borderRadius: 40, fontSize: 13, fontWeight: 'bold', color: '#fff', border: 'none' }}>
                      <p>Add new map</p>
                    </button>
                  </div>
                )}

                <div className="h-100 p-1" style={{ overflow: 'auto', flexWrap: 'wrap' }}>
                  <div className="row m-0" >
                    {this.state.data.map((prop, index) => {
                      return (
                        <div key={index} onClick={() => this.changeSelect(prop, index)} className="col-6 col-md-3 col-mg-4 flexcb cursor-pointer" style={{ border: this.state.selectedIndex == index ? '1px solid #007aff' : '1px solid #f2f6f8' }}>
                          <div className='w-100 h-100'>
                            <img src={prop.image} width={'100%'} height={"100%"} style={{ objectFit: 'contain' }} />
                            <p className="" style={{ fontSize: 20 }} >{prop.flag}</p>
                            <span>{prop.name}</span>
                          </div>

                        </div>
                      )
                    })}
                  </div>
                </div>

              </div>


              <div className="text-center px-2 pt-4 pb-4" style={{ overflow: 'auto', flex: 1, flexBasis: '300px', backgroundColor: '#f2f6f8', position: 'sticky', top: 0 }}>
                {this.state.selectedIndex == null ? (
                  <div className="h-100 flexcc flex-column">
                    <img src="/images/inputdef.svg" width="50px" />
                    <p className="text-center text-big text-bold mb-1 mt-1">No Selection</p>
                    <p className="text-center text-smaller">Select one image for it's information</p>
                  </div>
                ) : (
                  <div>

                    <img src={this.state.currentItem?.image} width={'100%'} onClick={() => { this.showBigImage() }} />
                    <button onClick={() => this.doneClicked()} style={{ outline: 'none', backgroundImage: 'linear-gradient(to right bottom,#00A7DA,#6F7BBE)', cursor: 'pointer', padding: '6px 30px', borderRadius: 40, fontSize: 13, fontWeight: 'bold', color: '#fff', border: 'none' }}>
                      <p>Use This Map</p>
                    </button>
                  </div>
                )}
              </div>

            </div>


            {/* <div className="text-center">
              <LoaderButton
                onClick={this.subscribe}
                isLoading={this.state.isLoading}
                text={translate("subscribe")}
                type={"Oval"}
                className="mt-3"
                buttonStyle={{ outline: 'none', backgroundImage: 'linear-gradient(to right bottom,#00A7DA,#6F7BBE)', cursor: 'pointer', padding: '10px 50px', borderRadius: 40, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                width={40}
                height={40}
                color={'#00A7DA'}
              />
            </div> */}


          </div>

          <Modal ref={el => this.imageModal = el} maxWidth={500}>
            <img src={this.state.currentItem?.image} style={{ width: '100%' }} />
          </Modal>


        </div>
      </Modal>
    );

  }
}


export default IndoorPickerModal;
